import { Col, Row } from "reactstrap";
import { useAppSelector } from "../../reduxToolkit/hooks";

import LogoWrapper from "./widgets/LogoWrapper";
import SearchBar from "./widgets/SearchBar";
import SearchInput from "./widgets/SearchInput";
import FullScreen from "./widgets/FullScreen";
import Notification from "./widgets/Notification";
import Bookmark from "./widgets/bookmark";
import Message from "./widgets/Message";
import Cart from "./widgets/cart";
import Mode from "./widgets/Mode";
import Language from "./widgets/Language";
import Profile from "./widgets/Profile";
import { useEffect,useState } from "react";
import ApiService from "../../services/apiService";
import {setCookies,getCookies} from '../../utils/cokkiesUtil'

const Header = () => {
  const [projectData,setProjectData] =  useState<any>()
  const[loading,setLoading] = useState(true)

  const { sideBarToggle } = useAppSelector((state) => state.themeCustomizer);

  useEffect(()=>{
    const fetchProjects = async () => {
      try {
          const response = await ApiService.axiosApi(`/projectsettings/getallproject`, {
              method: 'GET'
          })
          if (response.success) {
              setProjectData(response.data.data[0].projectName)
          } else {
              console.log(response.message || response.status || "unable to get projects")
          }
      } catch (error) {
          console.log(error)
      }finally{
        setLoading(false)
      }
  }
  fetchProjects();
   },[])

   if(loading){
      return <div>...loading</div>
   }

   


  return (
    <div className={`page-header ${sideBarToggle ? 'close_icon' : ''}`}  >
      <Col className="header-wrapper m-0  border-0" >
        <LogoWrapper />
             <span><h4 className="heading" style={{fontSize:'30px', fontWeight :'600',  fontFamily: 'Ysabeau, sans-serif', lineHeight:'42px'}}>{'Demo Application'}</h4></span>
              
      
   
        <Row xs="auto" lg="7" md="6" className="nav-right box-col-6 pull-right right-header p-0 ms-auto"  >
          <ul className="nav-menus" >
            <FullScreen/>
            <Mode/>
            <Profile/>
          </ul>
        </Row>
       
      </Col>
    </div>
  );
};

export default Header;
